<link href="https://cdn.jsdelivr.net/npm/@coreui/coreui@5.3.1/dist/css/coreui.min.css" rel="stylesheet"
  integrity="sha384-PDUiPu3vDllMfrUHnurV430Qg8chPZTNhY8RUpq89lq22R3PzypXQifBpcpE1eoB" crossorigin="anonymous">
<ng-container *transloco="let t">
  <nz-layout class="app-layout">
    <ng-template #notificationTemplate let-notifyData="data">

      <div class="custom-notification-header">
        <div class="custom-notification-icon">
          <ion-icon style="color: #3b82f6; font-size: 16px;" name="notifications-outline"></ion-icon>
        </div>
        <div class="notification-title body-sm-semibold one-line">{{ notifyData.title }}</div>
      </div>
      <img *ngIf="notifyData.image" [src]="notifyData.image" alt="Notification image" class="notification-image" />
      <div class="notification-body">
        <p class="body-sm-medium"> {{ notifyData.description }}</p>
      </div>
    </ng-template>

    <ng-template #languageDropdown>
      <a *ngFor="let lang of languageOptions" (click)="setLanguage(lang.code)" style="cursor: pointer; color:black">
        {{ lang.label }}
      </a>
    </ng-template>

    <nz-layout>
      <nz-sider *ngIf="this.generalService.isAltomateLink() && useDesktopMenu && checkMenuRequired()" [nzWidth]="318"
        class="menu-sidebar" nzCollapsible [(nzCollapsed)]="sideMenuvisible" [nzTrigger]="null"
        style="scrollbar-width: none;">

        <div *ngIf="sideMenuvisible === false" (click)="sideBarnavigateTo('home')"
          style="background-color: #64369F; display: flex; justify-content: center; cursor: pointer; padding: 3px 0; height: 46px;">
          <img style="height: 40px;" class="logo" src="assets/icon/common/altomate_logo.png" alt="">
        </div>

        <div *ngIf="sideMenuvisible === true" (click)="sideBarnavigateTo('home')"
          style="background-color: #64369F; display: flex; align-items: center; cursor: pointer; justify-content: center; padding: 3px 0; height: 46px;">
          <img style="height: 28px;" class="logo"
            src="https://altomate.io/wp-content/uploads/2024/02/Altomate-Logo-no-padding.png" alt="">
        </div>

        <div style="border-right: 1px solid #E4E0EB !important; height: calc(100% - 47px);">
          <div *ngIf="sideMenuvisible === false" class="sidebar-header">
            <img
              [src]="currentUser?.['profile_img']?.['url'] || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'"
              alt="">
            <div class="sidebar-profile">
              <span style="line-height: 13px; margin-bottom: 2px;">
                {{ this.currentUser['first_name'] + ' ' + this.currentUser['last_name'] }}
              </span>
              <span style="color: #7F778E; font-size: 11px;"> {{ this.user['email'] }} </span>
            </div>

            <ion-icon (click)="toggleSideMenu()" class="sidebar-icon" style="color: #C6C3CC;" name="close-outline">
            </ion-icon>
          </div>


          <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" style="padding-right: 1px;">


            <li (click)="toggleSideMenu()" *ngIf="sideMenuvisible === true" class="item-menu" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">
                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" name="menu-outline"></ion-icon>
                </span>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('home')"
              [ngClass]="currentUrl === 'home' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">
                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/home.svg"></ion-icon>
                </span>


                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Home') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('kyc')"
              [ngClass]="currentUrl === 'kyc' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">
                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/id_verification.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('ID Verification') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('businesses')" class="item-menu"
              [ngClass]="currentUrl === 'businesses' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/business.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" style="width: calc(100% - 114px);" class="sidebar-title">
                  {{ t('Businesses') }}
                </div>

              </div>
            </li>

            <li (click)="sideBarnavigateTo('profile')"
              [ngClass]="currentUrl === 'profile' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/profile.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Profile') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Plan & Billing')" (click)="sideBarnavigateTo('billings')"
              [ngClass]="currentUrl === 'billings' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/billing.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Plans & Billing') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Document')" (click)="sideBarnavigateTo('documents')"
              [ngClass]="currentUrl === 'documents' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/folder.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Documents') }}</div>
              </div>
            </li>


            <li *ngIf="hasCompanyPermission('Team')" (click)="sideBarnavigateTo('management')"
              [ngClass]="currentUrl === 'management' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/team.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Team') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('shop-services')"
              [ngClass]="currentUrl === 'shop-services' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/shop-add.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Shop Services') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Company Info')" (click)="sideBarnavigateTo('company-info')"
              [ngClass]="currentUrl === 'company-info' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/company-info.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Company Info') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Company Secretary')" (click)="sideBarnavigateTo('resolution-list')"
              [ngClass]="currentUrl === 'resolution-list' ? 'item-menu active-page' : 'item-menu'" nz-menu-item
              nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/company-secretary.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Company Secretary') }}</div>
              </div>
            </li>


            <li *ngIf="generalService.lengOfObject(this.selectedCompany) > 0"
              (click)="sideBarnavigateTo(getAccountingNavigationTarget())"
              [ngClass]="accountingSectionActive() ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/accounting.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Accounting') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('ai-chat')"
              [ngClass]="currentUrl === 'ai-chat' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right" [nzTooltipTitle]="sideMenuvisible ? t('AI Chat') : null">
              <div class="sidebar-container">
                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" name="chatbubbles-outline"></ion-icon>
                </span>
                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('AI Chat') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('payroll')"
              [ngClass]="currentUrl === 'payroll' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" src="assets/svg/shop-add.svg"></ion-icon>
                </span>

                <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Payroll')}}<span
                    style="margin-left: 6px; padding: 1px 6px; font-size: 9px; font-weight: 600; line-height: 1.4; text-transform: uppercase; letter-spacing: 0.3px; color: #6C5CE7; background: #EFEBFF; border-radius: 8px; vertical-align: middle;">Beta</span>
                </div>
              </div>
            </li>

            <!-- <li *ngIf="this.currentUser['isPartner'] === true" (click)="sideBarnavigateTo('customers')"
            [ngClass]="currentUrl === 'customers' ? 'item-menu active-page' : 'item-menu'" nz-menu-item nz-tooltip
            nzTooltipPlacement="right">
            <div class="sidebar-container">

              <span style="display: flex;">

                <ion-icon class="sidebar-icon" style="color: #736a82;" name="people-outline"></ion-icon>
              </span>

              <div *ngIf="sideMenuvisible === false" class="sidebar-title">{{ t('Customer List') }}</div>
            </div>
          </li> -->

            <li class="item-menu language-switch-item" nz-menu-item nz-tooltip nzTooltipPlacement="right">
              <div *ngIf="sideMenuvisible === false" class="sidebar-container language-switch-container">
                <div class="sidebar-lang-switch">
                  <button *ngFor="let lang of languageOptions"
                    (click)="setLanguage(lang.code); $event.stopPropagation()"
                    [class.active]="currentLang === lang.code">
                    {{ lang.label }}
                  </button>
                </div>
              </div>
              <div *ngIf="sideMenuvisible === true" class="sidebar-container language-switch-collapsed"
                (click)="toggleDropdown($event, languageDropdown)">
                <span style="display: flex;">
                  <ion-icon class="sidebar-icon" name="language-outline"></ion-icon>
                </span>
              </div>
            </li>


            <li *ngIf="sideMenuvisible === true" (click)="openWhatsapp()" class="item-menu" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex; padding: 6px 12px; border-radius: 8px; background-color: var(--green);">
                  <ion-icon style="font-size: 22px; margin-bottom: 1px;" src="assets/svg/support.svg"></ion-icon>
                </span>
              </div>
            </li>

            <li *ngIf="sideMenuvisible === true" (click)="signOut()" class="item-menu" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">

                <span style="display: flex; padding: 6px 12px; border-radius: 8px; border: 1px solid #E4E0EB;">
                  <ion-icon style="font-size: 22px; margin-bottom: 1px;" src="assets/svg/logout.svg"></ion-icon>
                </span>
              </div>
            </li>





          </ul>

          <div *ngIf="sideMenuvisible === false"
            style="display: flex; margin-top: 20px; gap: 20px; justify-content: center;">


            <div (click)="openWhatsapp()" class="support-button">
              <ion-icon style="font-size: 22px; margin-bottom: 1px;" src="assets/svg/support.svg"></ion-icon>
              <div>
                {{ t('Support') }}
              </div>
            </div>



            <div (click)="signOut()" class="signout-button">
              <ion-icon style="font-size: 22px; margin-bottom: 1px;" src="assets/svg/logout.svg"></ion-icon>

              <div>{{ t('Sign out') }}</div>
            </div>



          </div>

          <div class="versioning" *ngIf="sideMenuvisible === false">
            {{ t('Version') }}: V {{ this.generalService.isNativePlatform() ? (generalService.inAppVersion === '' ?
            generalService.currentVersion : generalService.inAppVersion) : generalService.currentVersion }}
          </div>
        </div>



      </nz-sider>

      <!-- [nzVisible]="sideMenuvisible" -->

      <nz-drawer *ngIf="this.generalService.isAltomateLink() && !useDesktopMenu && currentUrl !== 'new-home' && currentUrl !== 'new-documents'" [nzVisible]="sideMenuvisible"
        [nzWidth]="318" [nzClosable]="false" nzPlacement="left" (nzOnClose)="toggleSideMenu()"
        style="scrollbar-width: none;">
        <ng-container *nzDrawerContent style="margin: 0; padding: 0; overflow: auto;">
          <div class="sidebar-header" style="padding-top: var(--safe-area-inset-customtop2);">

            <img
              [src]="currentUser?.['profile_img']?.['url'] || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'"
              alt="">



            <div class="sidebar-profile">
              <span style="line-height: 13px; margin-bottom: 2px;">
                {{ this.user['first_name'] + ' ' + this.user['last_name'] }}
              </span>
              <span style="color: #7F778E; font-size: 11px;">{{ this.user['email'] }}</span>
            </div>


            <ion-icon (click)="toggleSideMenu()" class="sidebar-icon" style="color: #C6C3CC;"
              name="close-outline"></ion-icon>

          </div>

          <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" style="background-color: #FDFCFF;">
            <li (click)="sideBarnavigateTo('home')" [ngClass]="currentUrl === 'home' ? 'active-page' : ''" nz-menu-item
              nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/home.svg"></ion-icon>
                <div class="sidebar-title">{{ t('Home') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('kyc')" nz-menu-item nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/id_verification.svg"></ion-icon>
                <div class="sidebar-title">{{ t('ID Verification') }}</div>
              </div>
            </li>

            <li nz-menu-item nz-tooltip nzTooltipPlacement="right">
              <div (click)="sideBarnavigateTo('businesses')" class="sidebar-container">
                <ion-icon style="width: 24px;" class="sidebar-icon" src="assets/svg/business.svg"></ion-icon>
                <div style="width: calc(100% - 114px);" class="sidebar-title">{{ t('Businesses') }}</div>

                <!-- <div
                style="width: 80px; padding: 5px 15px 5px 8px; border-radius: 8px; gap: 5px; height: 30px; background-color: #64369F; display: flex; align-items: center;">
                <ion-icon style="font-size: 22px; color: white;" name="add-outline"></ion-icon>
                <div style="color: white;">
                  New
                </div>
              </div> -->
              </div>
            </li>

            <li (click)="sideBarnavigateTo('profile')" nz-menu-item nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/profile.svg"></ion-icon>
                <div class="sidebar-title">{{ t('Profile') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Plan & Billing')" (click)="sideBarnavigateTo('billings')" nz-menu-item
              nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/billing.svg"></ion-icon>
                <div class="sidebar-title">{{ t('Plans & Billing') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Document')" (click)="sideBarnavigateTo('documents')" nz-menu-item
              nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/folder.svg"></ion-icon>

                <div class="sidebar-title">{{ t('Documents') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Team')" (click)="sideBarnavigateTo('management')" nz-menu-item nz-tooltip
              nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/team.svg"></ion-icon>
                <div class="sidebar-title">{{ t('Team') }}</div>
              </div>
            </li>

            <li (click)="sideBarnavigateTo('shop-services')" nz-menu-item nz-tooltip nzTooltipPlacement="right">
              <div class="sidebar-container">
                <ion-icon class="sidebar-icon" src="assets/svg/shop-add.svg"></ion-icon>
                <div class="sidebar-title">{{ t('Shop Services') }}</div>
              </div>
            </li>

            <li *ngIf="hasCompanyPermission('Company Info')" (click)="sideBarnavigateTo('company-info')" nz-menu-item
              nz-tooltip nzTooltipPlacement="right" style="border-top: 1px solid #E4E0EB;">
              <div class="sidebar-container">
                <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">{{ t('Company Info') }}
                </div>
                <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>
              </div>
            </li>



            <li *ngIf="hasCompanyPermission('Company Secretary')" (click)="sideBarnavigateTo('resolution-list')"
              nz-menu-item nz-tooltip nzTooltipPlacement="right" style="border-top: 1px solid #E4E0EB;">
              <div class="sidebar-container">
                <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">{{ t('Company Secretary')
                  }}
                </div>

                <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>

              </div>
            </li>


            <li (click)="sideBarnavigateTo(getAccountingNavigationTarget())" nz-menu-item nz-tooltip
              nzTooltipPlacement="right" style="border-top: 1px solid #E4E0EB;">
              <div class="sidebar-container">
                <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">{{ t('Accounting') }}</div>

                <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>

              </div>
            </li>

            <li (click)="sideBarnavigateTo('ai-chat')" nz-menu-item
              [ngClass]="currentUrl === 'ai-chat' ? 'item-menu active-page' : 'item-menu'"
              style="border-top: 1px solid #E4E0EB;">
              <div class="sidebar-container">
                <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">{{ t('AI Chat') }}</div>
                <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>
              </div>
            </li>

            <!-- <li *ngIf="hasCompanyPermission('Payroll')" (click)="sideBarnavigateTo('payroll')" nz-menu-item nz-tooltip nzTooltipPlacement="right"
            style="border-top: 1px solid #E4E0EB;">
            <div class="sidebar-container">
              <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">{{ t('Payroll') }}</div>

              <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>

            </div>
          </li> -->

            <!-- <li *ngIf="this.currentUser['isPartner'] === true" (click)="sideBarnavigateTo('customers')" nz-menu-item
            nz-tooltip nzTooltipPlacement="right" style="border-top: 1px solid #E4E0EB;">
            <div class="sidebar-container">
              <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">{{ t('Customer List') }}
              </div>

              <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>

            </div>
          </li> -->

            <li nz-menu-item nz-tooltip nzTooltipPlacement="right" class="language-switch-item-mobile">
              <div class="sidebar-container language-switch-container-mobile">
                <div class="sidebar-lang-switch">
                  <button *ngFor="let lang of languageOptions" (click)="setLanguage(lang.code)"
                    [class.active]="currentLang === lang.code">
                    {{ lang.label }}
                  </button>
                </div>
              </div>
            </li>

            <!-- <li (click)="sideBarnavigateTo('resolutions/others')" nz-menu-item nz-tooltip nzTooltipPlacement="right"
          style="border-top: 1px solid #E4E0EB;">
          <div class="sidebar-container">
            <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">Tax</div>

            <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>

          </div>
        </li> -->


            <!-- <li (click)="sideBarnavigateTo('resolutions/others')" nz-menu-item nz-tooltip nzTooltipPlacement="right"
          style="border-top: 1px solid #E4E0EB; border-bottom: 1px solid #E4E0EB;">
          <div class="sidebar-container">
            <div style="width: calc(100% - 22px); color: #7F778E;" class="sidebar-title">Payroll</div>

            <ion-icon style="font-size: 22px; color: #7F778E;" name="chevron-forward-outline"></ion-icon>

          </div>
        </li> -->


            <!-- <li nz-submenu nzOpen nzTitle="Dashboard" nzIcon="dashboard">
        <ul>
          <li nz-menu-item>
            <a routerLink="/welcome">Welcome</a>
          </li>
          <li nz-menu-item>
            <a>Monitor</a>
          </li>
          <li nz-menu-item>
            <a>Workplace</a>
          </li>
        </ul>
      </li>
      <li nz-submenu nzOpen nzTitle="Form" nzIcon="form">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a>Basic Form</a>
          </li>
        </ul>
      </li> -->
          </ul>

          <div style="display: flex; margin-top: 20px; gap: 20px; justify-content: center;">


            <div (click)="openWhatsapp()" class="support-button">
              <ion-icon style="font-size: 22px; margin-bottom: 1px;" src="assets/svg/support.svg"></ion-icon>
              <div>
                {{ t('Support') }}
              </div>
            </div>

            <div (click)="signOut()" class="signout-button">
              <ion-icon style="font-size: 22px; margin-bottom: 1px;" src="assets/svg/logout.svg"></ion-icon>
              <div>{{ t('Sign out') }}</div>
            </div>

          </div>

          <div class="versioning">
            {{ t('Version') }}: V {{ this.generalService.isNativePlatform() ? (generalService.inAppVersion === '' ?
            generalService.currentVersion : generalService.inAppVersion) : generalService.currentVersion }}
          </div>
        </ng-container>
      </nz-drawer>

      <nz-drawer *ngIf="this.generalService.isAltomateLink()" [nzWidth]="318" [nzClosable]="false"
        [nzVisible]="notificationMenuVisible" nzPlacement="right" (nzOnClose)="toggleNotificationSideMenu()">
        <ion-content class="safe-content" *nzDrawerContent style="margin: 0; padding: 0;">

          <div style="padding: 15px 10px; display: flex; gap: 10px; align-items: center; height: 56px;">

            <ion-icon (click)="toggleNotificationSideMenu()"
              style="font-size: 25px; color: #1E1725; margin-bottom: 4px; cursor: pointer" name="close">
            </ion-icon>

            <div class="body-md-semibold">
              {{ t('Notifications') }}
            </div>
          </div>

          <app-loading *ngIf="this.generalService.loadingNotifications === true"></app-loading>

          <div *ngFor="let noti of notifications" (click)="viewNotifications(noti)"
            style="display: flex; cursor: pointer; border-bottom: 1px solid #E4E0EB; align-items: flex-start; gap: 10px; padding: 16px;">
            <div style="position: relative;">
              <div *ngIf="noti['is_read'] === 0"
                style="position: absolute; height: 8px; width: 8px; border-radius: 100%; right: -3px; top: -4px; background-color: #FE0000;">
              </div>
              <img style="width: 32px; height: 32px;" [src]="noti['icon']" alt="">
            </div>
            <div style="width: calc(100% - 68px);">
              <div
                style="margin-bottom: 12px; font-size: 12px; font-weight: 600; line-height: 16.8px; letter-spacing: -0.01em; text-align: left;">
                {{ noti['title'] }} {{ noti['message'] }}
              </div>
              <div
                style="color: #7F778E; font-size: 11px; font-weight: 500; line-height: 15.4px; letter-spacing: -0.01em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">
                {{ noti['created_at'] | date: 'dd-MM-yyyy hh:mm a' }}
              </div>
            </div>

            <ion-icon style="align-self: center; width: 20px; font-size: 16px; color: #7F778E;"
              name="chevron-forward-outline"></ion-icon>

          </div>

          <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
            <ion-infinite-scroll-content></ion-infinite-scroll-content>
          </ion-infinite-scroll>


        </ion-content>
      </nz-drawer>


      <nz-header class="app-main-header" *ngIf="this.generalService.isAltomateLink() && useDesktopMenu && checkMenuRequired()">
        <div class="app-header">

          <div style="display: flex; cursor: pointer; align-items: center; width: 80%; gap: 12px;">
            <div (click)="generalService.showCompanyList($event)"
              style="width: 100%; max-width: 350px; display: flex; gap: 10px; align-items: center; padding: 4px 8px; border: 1px solid #8E67BF; border-radius: 8px; color: white; background-color: transparent;">
              <div class="body-md-semibold one-line" style="width: calc(100% - 32px); color: white;">
                {{ selectedCompany['display_name'] || 'New Business 1' }}
              </div>

              <ion-icon style="font-size: 22px; color: white;" name="chevron-down-outline"></ion-icon>

            </div>

            <button (click)="startNewBusiness()"
              style="height: fit-content; margin-top: 20px; background-color: transparent;">
              <ion-icon style="font-size: 25px;" src="assets/svg/add-business.svg"></ion-icon>
            </button>
          </div>

          <div style="display: flex; gap: 6px; margin-bottom: -10px;">
            <div style="position: relative ; ">
              <ion-icon (click)="this.generalService.showProgressBar()" class="header-trigger trigger"
                style="font-size: 19px; margin-bottom: 2px; color: white; justify-self: end; cursor: pointer;"
                src="assets/svg/checklist.svg">
              </ion-icon>
            </div>

            <div style="position: relative ;">
              <div
                style="position: absolute; height: 8px; width: 8px; border-radius: 100%; right: 1px; top: 17px; z-index: 1; background-color: #FE0000;">
              </div>

              <ion-icon (click)="toggleNotificationSideMenu()" class="header-trigger trigger"
                style="font-size: 20px;  color: white; justify-self: end; cursor: pointer;" name="notifications">
              </ion-icon>
            </div>
          </div>





          <!-- <ion-icon (click)="toggleNotificationSideMenu()" class="header-trigger trigger icon"
          style="font-size: 23px; margin-bottom: 3px; color: white; justify-self: end; cursor: pointer;" name="notifications"></ion-icon> -->

        </div>

        <!-- <div style="overflow: scroll; background-color: #FDFCFF; scrollbar-width: none; ">
        <ion-segment mode="md" [(ngModel)]="currentUrl" (ionChange)="sideBarnavigateTo($event.detail.value)"
          style="min-width: 760px; border-bottom: 1px solid #E4E0EB; display: flex; gap: 16px; justify-content: flex-start;">
          <ion-segment-button class="segment-button" value="home">
            <div class="segment-container">
              <img style="height: 20px; margin-bottom: 4px"
                src="https://altomate.io/wp-content/uploads/2024/02/Altomate-Logo-no-padding.png" alt="">
              <div
                [ngClass]="currentUrl === 'home' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Home
              </div>
            </div>
          </ion-segment-button>

          <ion-segment-button class="segment-button" value="documents">
            <div class="segment-container">
              <ion-icon class="sidebar-icon" src="assets/svg/folder.svg"></ion-icon>
              <div
                [ngClass]="currentUrl === 'documents' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Docs
              </div>
            </div>
          </ion-segment-button>
          <ion-segment-button class="segment-button" value="task-list">
            <div class="segment-container">
              <ion-icon class="sidebar-icon" src="assets/svg/tasks.svg"></ion-icon>
              <div
                [ngClass]="currentUrl === 'task-list' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Tasks</div>
            </div>
          </ion-segment-button>
          <ion-segment-button class="segment-button" value="accounting">
            <div class="segment-container">
              <ion-icon class="sidebar-icon" src="assets/svg/accounting.svg"></ion-icon>
              <div
                [ngClass]="currentUrl === 'accounting' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Accounts</div>
            </div>
          </ion-segment-button>
          <ion-segment-button class="segment-button" value="resolution-list">
            <div class="segment-container">
              <ion-icon class="sidebar-icon" src="assets/svg/company-secretary.svg"></ion-icon>
              <div
                [ngClass]="currentUrl === 'resolution-list' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Company Secretary</div>
            </div>
          </ion-segment-button>
          <ion-segment-button class="segment-button" value="company-info">
            <div class="segment-container">
              <ion-icon class="sidebar-icon" src="assets/svg/company-info.svg"></ion-icon>
              <div
                [ngClass]="currentUrl === 'company-info' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Company Info</div>
            </div>
          </ion-segment-button>
        </ion-segment>
      </div> -->

        <!-- <div *ngIf="domainValid()" style="overflow: scroll; background-color: #FDFCFF; scrollbar-width: none; ">
        <ion-segment mode="md" [(ngModel)]="currentDomainUrl" (ionChange)="sideBarnavigateTo($event.detail.value)"
          style="min-width: 760px; border-bottom: 1px solid #E4E0EB; display: flex; gap: 16px; justify-content: flex-start;">

          <ion-segment-button class="segment-button" value="domains/home">
            <div class="segment-container">
              <div
                [ngClass]="!(currentDomainUrl.includes('domains/search-domains') || currentDomainUrl.includes('domains/home')) ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Search your domain
              </div>
            </div>
          </ion-segment-button>

          <ion-segment-button class="segment-button" value="domains/my-domains">
            <div class="segment-container">
              <div
                [ngClass]="currentDomainUrl === 'domains/my-domains' ? 'body-sm-semibold segment-top-text-active' : 'body-sm-semibold segment-top-text'">
                Your Domains
              </div>
            </div>
          </ion-segment-button>
        </ion-segment>
      </div> -->

        <!-- Accounting top bar, New Home design: one row of groups, each opening its pages
             in a dropdown. The groups and links are ACCOUNTING_NAV in app.component.ts;
             paid-tier links are left out for the free tier there. -->
        <div #accountingBar class="payroll-header-container acc-nav" *ngIf="accountingValid()">
          <div class="acc-nav__row">
            <a class="acc-nav__title" routerLink="/accounting/home" routerDirection="root">
              <span class="acc-nav__mark" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3h14v18H5zM8 7h8M8 12h2M12 12h4M8 16h2M12 16h4"/></svg>
              </span>
              Accounting
            </a>
            <span class="acc-nav__sep" aria-hidden="true"></span>

            <nav class="acc-nav__groups" aria-label="Accounting">
              <div *ngFor="let group of accountingNavGroups" class="acc-nav__item"
                (mouseenter)="openAccountingGroup = group.label" (mouseleave)="closeAccountingGroup(group)"
                (keydown.escape)="closeAccountingGroup(group)">
                <!-- A group with one page is a plain link. -->
                <a *ngIf="visibleAccountingLinks(group).length === 1" class="acc-nav__group" routerDirection="root"
                  [routerLink]="accountingLinkPath(visibleAccountingLinks(group)[0])"
                  [class.acc-nav__group--active]="group === activeAccountingGroup"
                  [attr.aria-current]="group === activeAccountingGroup ? 'page' : null">{{ group.label }}</a>

                <!-- A group with several opens its pages on hover; a tap or Enter opens it too. -->
                <ng-container *ngIf="visibleAccountingLinks(group).length > 1">
                  <button type="button" class="acc-nav__group" aria-haspopup="true"
                    [class.acc-nav__group--active]="group === activeAccountingGroup"
                    [class.acc-nav__group--open]="openAccountingGroup === group.label"
                    [attr.aria-expanded]="openAccountingGroup === group.label"
                    (click)="toggleAccountingGroup(group)">
                    {{ group.label }}
                    <svg class="acc-nav__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
                  </button>
                  <div *ngIf="openAccountingGroup === group.label" class="acc-nav__menu">
                    <a *ngFor="let link of visibleAccountingLinks(group)" class="acc-nav__link" routerDirection="root"
                      [routerLink]="accountingLinkPath(link)" [queryParams]="accountingLinkQuery(link)"
                      (click)="openAccountingGroup = null"
                      [class.acc-nav__link--active]="isAccountingLinkActive(link)"
                      [attr.aria-current]="isAccountingLinkActive(link) ? 'page' : null">{{ link.label }}</a>
                  </div>
                </ng-container>
              </div>
            </nav>

            <!-- Leaves the module for the subscription, so it sits apart at the end of the bar. -->
            <div class="acc-nav__end">
              <a routerLink="/accounting/engagement" routerDirection="root" class="acc-nav__plan"
                [class.acc-nav__plan--active]="onAccountingPlanPage()"
                [attr.aria-current]="onAccountingPlanPage() ? 'page' : null">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9 13h6M9 17h6"/></svg>
                {{ isAccountingBookkeeping ? 'My Engagement' : 'My Plan' }}
                <span class="acc-nav__flag" *ngIf="accountingNeedsAttention"
                      aria-label="Something needs your attention">!</span>
              </a>
            </div>
          </div>

        </div>
        <!-- Payroll module navigation — matches Figma template (Overview / Payroll / Employees / Reports + Settings) -->
        <div class="payroll-header-container" *ngIf="payrollValid()">

          <!-- Row 1: Title + tagline -->
          <div class="payroll-title-row">
            <h3 class="payroll-title">Payroll</h3>
            <span class="payroll-tagline">Automated payroll, effortless operations</span>
          </div>

          <!-- Row 2: Tabs (left) + Settings (right) -->
          <div class="payroll-tabs-row">
            <ul nz-menu nzMode="horizontal" nzTheme="light" class="custom-menu payroll-tabs">

              <!-- Overview -->
              <li nz-menu-item>
                <a href="/payroll/payroll-dashboard">Overview</a>
              </li>

              <!-- Payroll -->
              <li nz-menu-item>
                <a href="/payroll/run-payroll">Payroll</a>
              </li>

              <!-- Employees (dropdown) -->
              <li nz-submenu nzTitle="Employees">
                <ul>
                  <li nz-menu-item>
                    <a href="/payroll/employee-list">Employee List</a>
                  </li>
                  <li nz-menu-item>
                    <a href="/payroll/attendance">Attendance</a>
                  </li>
                </ul>
              </li>

              <!-- Reports (dropdown) -->
              <li nz-submenu nzTitle="Reports">
                <ul>
                  <li nz-menu-item>
                    <a href="/payroll/payroll-reports">Payroll Reports</a>
                  </li>
                  <!-- <li nz-menu-item>
                    <a href="/payroll/form-e">Form E</a>
                  </li>
                  <li nz-menu-item>
                    <a href="/payroll/form-ea">Form EA</a>
                  </li> -->
                </ul>
              </li>
            </ul>

            <!-- Settings — right-aligned standalone control -->
            <ng-template #payrollSettingsTitle>
              <span nz-icon nzType="setting" nzTheme="outline" class="settings-icon"></span>
              <span class="settings-label">Settings</span>
            </ng-template>

            <ul nz-menu nzMode="horizontal" nzTheme="light" class="custom-menu payroll-settings-menu">
              <li nz-submenu [nzTitle]="payrollSettingsTitle">
                <ul>
                  <li nz-menu-item>
                    <a href="/payroll/payroll-settings">Payroll Settings</a>
                  </li>
                  <li nz-menu-item>
                    <a href="/payroll/company-settings">Company Settings</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>


      </nz-header>
      <nz-content class="inner-content">
        <!-- <router-outlet></router-outlet> -->
        <div class="toast-container-top" id="toastContainerTop">
          <!-- Top toasts will be dynamically inserted here -->
        </div>
        <div class="toast-container-bottom" id="toastContainerBottom">
          <!-- Bottom toasts will be dynamically inserted here -->
        </div>

        <ion-router-outlet></ion-router-outlet>
      </nz-content>

      <nz-footer>
        <!-- <div class="footer-container" style="width: 100%; margin: 0 auto">
        <div *ngFor="let item of footers" class="footer">
          <div class="footer-line"> </div>
          <div class="footer-contain">
            <img src="{{item.url}}">
            <div> {{ item.title }} </div>
          </div>

        </div>
      </div> -->


      </nz-footer>
    </nz-layout>

    <div @fadeInOut *ngIf="this.generalService.showImageNotification.show === true" appResizeObserver
      (widthChanged)="onWidthChange($event)" class="popup-container">

      <div (click)="this.generalService.showImageNotification.show = false"
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;">
      </div>

      <swiper-container class="popup-swiper" style="cursor: pointer; position: relative; height: 100%;" appSwiper
        #bankswiper [config]="popUpConfig">

        <div (click)="this.generalService.showImageNotification.show = false"
          style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;">
        </div>

        <swiper-slide class="form-slide"
          style="display: flex; position: relative; justify-content: center; align-items: center;">
          <div (click)="this.generalService.showImageNotification.show = false"
            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;">

          </div>

          <div style="position: relative;">
            <ion-icon (click)="this.generalService.showImageNotification.show = false"
              style="cursor: pointer; background-color: white; border-radius: 100%; font-size: 20px; top: 10px; right: 10px; position: absolute; z-index: 2;"
              name="close-outline">
            </ion-icon>
            <img style="width: 100%; height: 100%; object-fit: cover;"
              src="{{this.generalService.showImageNotification.image}}" alt="">

            <div (click)="this.generalService.readImageNotification()" class="body-md-semibold"
              style="margin-top: 12px; width: 100%; padding: 12px 0; background-color: var(--green); color: white; display: flex; justify-content: center;">
              READ
            </div>
          </div>

        </swiper-slide>
      </swiper-container>



    </div>
    <div *ngIf="isUpgradeModalVisible" class="upgrade-modal-overlay" (click)="isUpgradeModalVisible = false">
      <div class="upgrade-modal-content" (click)="$event.stopPropagation()">
        <ion-icon name="close-outline" class="close-icon" (click)="isUpgradeModalVisible = false"></ion-icon>

        <!-- IMPORTANT: Replace this src with the actual path to your price list image -->
        <img style="height: 75vh;" src="/assets/image/pop-up_1.png" alt="Price List Poster" class="price-list-poster" />

        <button class="upgrade-action-button" (click)="navigateToShopServices()">
          I want to upgrade!
        </button>
      </div>
    </div>

  </nz-layout>

  <app-consent-manager></app-consent-manager>
</ng-container>
